<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style3', { sticky: isSticky }]">
      <MainNavbar />
    </div>
    <MainBanner />
    <OurFeatures />
    <CompanyIntroduction />
    <BestServices />
    <OurDepartment />
    <GalleryExhibition />
    <OurPricing />
    <PeopleAlsoAsk />
    <OurDoctors />
    <OurTestimonials />
    <CallToAction />
    <LatestNews />
    <MainFooter />
  </div>
</template>

<script lang="ts">
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeThree/MainBanner.vue";
import OurFeatures from "../HomeThree/OurFeatures.vue";
import CompanyIntroduction from "../HomeThree/CompanyIntroduction.vue";
import BestServices from "../HomeThree/BestServices.vue";
import OurDepartment from "../HomeThree/OurDepartment.vue";
import GalleryExhibition from "../HomeThree/GalleryExhibition.vue";
import OurPricing from "../HomeThree/OurPricing.vue";
import PeopleAlsoAsk from "../HomeThree/PeopleAlsoAsk.vue";
import OurDoctors from "../HomeThree/OurDoctors.vue";
import OurTestimonials from "../HomeThree/OurTestimonials.vue";
import CallToAction from "../HomeThree/CallToAction.vue";
import LatestNews from "../HomeThree/LatestNews.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeThreePage",
  components: {
    MainNavbar,
    MainBanner,
    OurFeatures,
    CompanyIntroduction,
    BestServices,
    OurDepartment,
    GalleryExhibition,
    OurPricing,
    PeopleAlsoAsk,
    OurDoctors,
    OurTestimonials,
    CallToAction,
    LatestNews,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>